import React, {useState, useEffect} from 'react'
import HeadingArea from '../../general/HeadingArea'
import ResponseMsg2 from '../../general/ResponseMsg2'
import { FaCheck } from 'react-icons/fa';
import { RiDeleteBin6Line } from 'react-icons/ri';


const AssignClassTeacher = ({setLoading}) => {
      const [response2, setResponse2] = useState({ message: '', status: 'success' });
 const [emp, setEmp] = useState([]);
 const [classes, setClasses] = useState([]);

   const [selectedClassId, setSelectedClassId] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [selectedTeacherId, setSelectedTeacherId] = useState('');
  const [showDelete, setShowDelete] = useState(false);
  const [selectedClass, setSelectedClass]= useState('');
const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [availableSections, setAvailableSections] = useState([]);
const [searchTerm, setSearchTerm] = useState('');


     const fetchClasses = async () => {
                           setLoading(true);
                   try {
                       const response = await fetch('https://api.kcian.in/get-classes');
       
                       if (response.ok) {
                           const data = await response.json();
                          //  const filter = data.filter((d) => d.class_teacher != null);
                           setClasses(data);
                           setLoading(false);
                                                     console.log(data);

                       } else {
                           setLoading(false);
                           console.error('Failed to fetch class');
                       }
                   } catch (error) {
                       setLoading(false);
                       console.error('Error fetching data:', error);
                   }
     }


         const fetchEmp = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-employee');
      
                      if (response.ok) {
                          const data = await response.json();
 const filteredData = data.filter(emp => emp.role == 'Teacher');
                          setEmp(filteredData);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch employee');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }

 
     useEffect(() => {
         fetchClasses();
         fetchEmp();
     }, []);
      

useEffect(() => {
  if (selectedClassId) {
const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));

    if (selectedClass && selectedClass.sections) {
      const sectionArray = selectedClass.sections
        .split(',')
        .map((s) => s.trim()) 
        .filter((s) => s !== '');

      setAvailableSections(sectionArray);
    } else {
      setAvailableSections([]);
    }

    setSelectedSection('');
  }
}, [selectedClassId, classes]);



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedClassId || !selectedSection || !selectedTeacherId) {
      setResponse2({ message: 'Please fill all fields.', status: 'error' });
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`https://api.kcian.in/assign-class-teacher/${selectedClassId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
body: JSON.stringify({
  class_teacher: `${selectedSection}:${selectedTeacherId}`,
}),
      });

      if (response.ok) {
        const data = await response.json();
        setResponse2({ message: data.message || 'Teacher Assigned Successfully!', status: 'success' });
        // Reset form
        setSelectedClassId('');
        setSelectedTeacherId('');
        setSelectedSection('');
        setAvailableSections([]);
        fetchClasses();
      } else {
        const error = await response.json();
        setResponse2({ message: error.message || 'Something went wrong', status: 'error' });
      }
    } catch (error) {
      console.error('Error assigning teacher:', error);
      setResponse2({ message: 'Failed to assign teacher. Try again.', status: 'error' });
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };


const handleShowDelete = (cls, teacherInfo) => {
  setSelectedClass(cls);
  setSelectedTeacher(teacherInfo);
  setShowDelete(true);
};


const handleDelete = async () => {
  if (!selectedClass || !selectedTeacher) return;
  setLoading(true);

  try {
    const response = await fetch(`https://api.kcian.in/remove-class-teacher/${selectedClass.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
class_teacher: `${selectedTeacher.section}:${selectedTeacher.teacherId}`
      }), 
    });

    if (response.ok) {
      fetchClasses();
      setShowDelete(false);
  setLoading(false);
      setResponse2({ message: 'Teacher Removed Successfully!', status: 'success' });
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    } else {
  setLoading(false);
      setResponse2({ message: 'Failed to Remove Class Teacher.', status: 'error' });
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  } catch (error) {
    console.error('Error removing teacher:', error);
  }
};


  return (
    <>
            <section className="py-4">
        <div className="px-4">
          <HeadingArea message1="Classes" message2="Assign Class Teacher" />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


<div className='row'>

<div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
          <div className="profile-card">
            <p className="profile-heading">Assign Class Teacher</p>

<form onSubmit={handleSubmit} className='mt-4'>
                  {/* Select Class */}

                  <div className="mb-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Class*</label>
                    <select
                      className="profile-input"
                      value={selectedClassId}
                      onChange={(e) => setSelectedClassId(e.target.value)}
                      required
                    >
                      <option value="">-- Select Class --</option>
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class_name}
                        </option>
                      ))}
                    </select>
</div>
                  </div>

                  {/* Select Section */}
                  <div className="mb-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Section*</label>
<select
  className="profile-input"
  value={selectedSection}
  onChange={(e) => setSelectedSection(e.target.value)}
  required
  disabled={availableSections.length === 0}
>
  <option value="">-- Select Section --</option>
  {availableSections.map((section, idx) => (
    <option key={idx} value={section}>
      {section}
    </option>
  ))}
</select>

                    </div>
                  </div>

                  {/* Select Teacher */}
                  <div className="mb-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Teacher*</label>
                    <select
                      className="profile-input"
                      value={selectedTeacherId}
                      onChange={(e) => setSelectedTeacherId(e.target.value)}
                      required
                    >
                      <option value="">-- Select Teacher --</option>
                      {emp.map((teacher) => (
                        <option key={teacher.id} value={teacher.id}>
                          {teacher.name} &nbsp;&nbsp;--&nbsp;&nbsp; {teacher.user_id}
                        </option>
                      ))}
                    </select>
                    </div>
                  </div>

                  <div className="text-center">
                    <button type="submit" className="profile-btn">
                      <FaCheck /> Save
                    </button>
                  </div>
                </form>

</div>
</div>
{/* left section ends */}

<div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
<div className='profile-card'>
            {/* <p className="profile-heading">Class Teacher List</p> */}
  <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
            <span className="profile-heading align-content-center">Class Teacher List</span>


                  <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search Teacher...'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
  </div>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    {/* <th className='rounded-start-4'>S No</th> */}
    <th className='rounded-start-4'>Class</th>
    <th>Section</th>
    <th>Teacher</th>
    <th className='rounded-end-4'>Activity</th>
</thead>


<tbody>
  {classes.filter((c) => c.class_teacher != null).map((cls, index) => {
    if (cls.class_teacher) {
      // Split multiple assignments, e.g. "A:9,B:10"
      const entries = cls.class_teacher.split(',');

        const filteredEntries = entries.filter((entry) => {
        const [section, teacherId] = entry.split(':').map(s => s.trim());
        const teacher = emp.find(t => String(t.id) === teacherId);
        if (!teacher) return false;

        // Compare teacher name with search term (case-insensitive)
        return teacher.name.toLowerCase().includes(searchTerm.toLowerCase().trim());
      });

      // If no matching entries, skip rendering this class
      if (filteredEntries.length === 0) return null;

      return filteredEntries.map((entry, i) => {
        const [section, teacherId] = entry.split(':').map(s => s.trim());
        const teacher = emp.find(t => String(t.id) === teacherId);


        return (
          <tr key={`${cls.id}-${i}`} className='account-tr'>
            {/* <td>{index + 1}{entries.length > 1 ? `.${i + 1}` : ''}</td> */}
            <td>{cls.class_name}</td>
            <td>{section || '-'}</td>
            <td>{teacher ? teacher.name : 'Teacher'}</td>
    <td>
    {/* <MdOutlineEdit className='account-icon1' title='Edit' /> &nbsp;&nbsp; */}
    <RiDeleteBin6Line className='account-icon1' title='Remove' onClick={() => handleShowDelete(cls, { section, teacherId, teacher })} /></td>
          </tr>
        );
      });
    } else {
      return (
        <tr key={cls.id} className='account-tr'>
          {/* <td>{index + 1}</td> */}
          <td>{cls.class_name}</td>
          <td>-</td>
          <td>Not Assigned</td>
          <td>{/* Activity if any */}</td>
        </tr>
      );
    }
  })}
</tbody>


</table>
</div>
</div>
</div>
{/* right section ends */}


</div>
{/* row ends */}


</div>
</section>


      {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove "{selectedTeacher?.teacher?.name}" as Class Teacher {selectedClass.class_name} {selectedTeacher?.section}</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Class</th>
    <th>Section</th>
    <th className='rounded-end-4'>Name</th>
</thead>

<tr className='account-tr'>
<td>{selectedClass.class_name}</td>
<td>{selectedTeacher?.section}</td>
<td>{selectedTeacher?.teacher?.name}</td>

</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the class teacher will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedClass.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

    </>
  )
}

export default AssignClassTeacher
